export const sortPatients = patients =>
  // eslint-disable-next-line complexity
  patients.sort((a, b) => {
    if (a.data.name.last < b.data.name.last) return -1;
    if (a.data.name.last > b.data.name.last) return 1;
    if (a.data.name.first < b.data.name.first) return -1;
    if (a.data.name.first > b.data.name.first) return 1;
    if (a.data.name.middle < b.data.name.middle) return -1;
    if (a.data.name.middle > b.data.name.middle) return 1;
    if (a.data.name.preferred < b.data.name.preferred) return -1;
    if (a.data.name.preferred > b.data.name.preferred) return 1;
    return 0;
  });

export const searchPatients = (patientsList, value) => {
  const removeSpecialCharacters = str => str.replace(/[^a-zA-Z0-9 ]/g, '');

  const searchTerms = value.trim().toLowerCase().split(' ');

  return patientsList.filter(item => {
    const normalizedLabel = item.label.toLowerCase();

    return searchTerms.every(term =>
      normalizedLabel.includes(removeSpecialCharacters(term)),
    );
  });
};
